module.exports = __webpack_public_path__ + "img/logo.26ac9903.png";